import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, MapPin, ChevronRight } from 'lucide-react';
import { Sec, SH, formatTime, formatDate } from '../components/Shared';
import { POSTER_THEMES } from '../data/websiteData';

const CalendarPage = ({ events }) => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('Upcoming');

  // For demo, treat 'Completed' as past, everything else as upcoming
  // Since we don't have past events in mock data right now, we can show a placeholder if empty
  const isCompleted = ev => ev.status && ev.status.trim().toLowerCase() === 'completed';
  const filteredEvents = (events || []).filter(ev => filter === 'Upcoming' ? !isCompleted(ev) : isCompleted(ev));

  return (
    <div className="af">
      <Sec py={160} bg="var(--grad-hero)">
        <SH eyebrow="Timeline" title="Operation Log" sub="Our official schedule of workshops, talks, contests and community meetups." />
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginBottom: 64 }}>
          {['Upcoming', 'Past'].map(f => (
            <button 
              key={f}
              onClick={() => setFilter(f)}
              style={{
                padding: '10px 24px',
                borderRadius: 100,
                background: filter === f ? 'var(--on-surface)' : 'transparent',
                color: filter === f ? '#fff' : 'var(--slate-500)',
                border: `1px solid ${filter === f ? 'var(--on-surface)' : 'var(--slate-200)'}`,
                fontFamily: 'var(--font)',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all .2s'
              }}
            >
              {f} Events
            </button>
          ))}
        </div>

        <div className="g3" style={{ minHeight: '60vh', alignContent: 'start' }}>
          {filteredEvents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '100px 0', gridColumn: '1 / -1', color: 'var(--slate-500)', border: '1px dashed var(--border)', borderRadius: 12 }}>
              No {filter.toLowerCase()} events found in the database.
            </div>
          ) : (
            filteredEvents.map((ev, i) => (
              <div key={`${ev.slug || ev.id || 'ev'}-${i}`} className={`card au d${(i % 3) + 1}`} onClick={() => navigate(`/events/${ev.slug}`)} style={{ cursor: 'pointer', overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff', border: '1px solid var(--border)' }}>
                <div style={{ aspectRatio: '16/9', position: 'relative', overflow: 'hidden', background: 'var(--surface-container-low)' }}>
                  <div style={{ position: 'absolute', inset: 0, background: POSTER_THEMES[i % 6].bg, zIndex: 0 }} />
                  {ev.bannerImg && <img src={ev.bannerImg} alt={ev.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: 1 }} />}
                  <div style={{ position: 'absolute', top: 12, left: 12, zIndex: 2 }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', background: 'var(--primary)', padding: '4px 10px', borderRadius: 4, textTransform: 'uppercase', letterSpacing: '.1em' }}>{ev.type}</span>
                  </div>
                </div>
                <div style={{ padding: 24 }}>
                  <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                    <div style={{ background: 'var(--surface-container-low)', borderRadius: 8, padding: '8px 12px', textAlign: 'center', minWidth: 50 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase' }}>{formatDate(ev.month, 'month')}</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--on-surface)' }}>{formatDate(ev.day, 'day')}</div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--on-surface)', lineHeight: 1.3, marginBottom: 8 }}>{ev.title}</h3>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, fontSize: 12, color: 'var(--on-surface-variant)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Clock size={13} /> {formatTime(ev.time)}</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><MapPin size={13} /> {ev.loc}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: 'var(--primary)', borderTop: '1px solid var(--slate-100)', paddingTop: 16 }}>
                    Reserve Entry Protocol <ChevronRight size={14} />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </Sec>
    </div>
  );
};

export default CalendarPage;
